import owd from 'owd/owd';

export default class MenuScroll extends owd.Component {
	init() {
		this.bind();
		this.transformMenu();
	}

	bind() {
        this.on('scroll', this.dom.$window, this.transformMenu.bind(this));
	}

    transformMenu() {
        const menu = this.$element;
		const burger = $('.buttons-container');
		const header = $('.header');
		const headerHeight = header.outerHeight() + 200;
        const midHeight = menu.height() / 2;
		const topPosition = window.pageYOffset || document.documentElement.scrollTop;

		if (window.matchMedia('(min-width: 768px)').matches) {
	        if ( topPosition > midHeight ) {
	            header.addClass('is-scrolled');
				burger.addClass('is-visible');
	        } else {
	            // if (menu.hasClass('is-hidden')) {
	                header.removeClass('is-scrolled')
					burger.removeClass('is-visible');
	            // }
	        }
			if ( topPosition > headerHeight ) {
				// header.addClass('is-shrinked');
			} else {
				// header.removeClass('is-shrinked');
			}
		}

		if (window.matchMedia('(max-width: 767px)').matches) {
			// header.addClass('is-shrinked');
		}

    }
}

owd.registerComponent('menu-scroll', {
	component: MenuScroll
});
